import React, { useEffect, useState } from 'react';
import { useHistory, useParams, Link } from 'react-router-dom';
import SuperadminLayout from './SuperadminLayout';
import { Modal, Button } from 'react-bootstrap';
import axios from '../../axios/axiosconf';
import { formatDateOnly } from './superadminDateUtils';
import { ordenarListaAlfabetica } from './superadminSortUtils';
import './SuperadminStyles.css';

const getEstadoLabel = (estado) => {
    switch (parseInt(estado, 10)) {
        case 0: return 'Activo';
        case 1: return 'Bloqueado';
        case 2: return 'Retirado';
        case 3: return 'Pend. pago activo';
        default: return 'Sin estado';
    }
};

const getEstadoBadgeClass = (estado) => {
    switch (parseInt(estado, 10)) {
        case 0: return 'success';
        case 1: return 'warning';
        case 2: return 'danger';
        case 3: return 'info';
        default: return 'secondary';
    }
};

const PLANTILLAS_POR_PAGINA = 8;

const defaultFevNuevoForm = () => ({
    resolucion: '',
    prefijo: '',
    tipo: 'Factura Electronica',
    numero_factura: '',
    factura_inicial: '',
    factura_final: '',
    tipo_regimen: 'Sin IVA',
    habilitado: 1,
    fecha_vencimiento: '',
    users_id: '',
});

const PERIODO_LABELS = {
    mensual: 'Mensual',
    semestral: 'Semestral',
    anual: 'Anual',
};

const subtituloControlServicio = (svc) => {
    if (!svc || (!svc.activo && !svc.periodicidad && !svc.ultimo_reset && !svc.fecha_inicio)) {
        return (
            <span className="text-muted font-weight-normal small ml-1">
                · Sin control configurado
            </span>
        );
    }
    const periodo = svc.periodicidad
        ? (PERIODO_LABELS[svc.periodicidad] || svc.periodicidad)
        : '—';
    const fechaRecarga = svc.fecha_inicio ? formatDateOnly(svc.fecha_inicio) : '—';
    const ultimaRenovacion = svc.ultimo_reset ? formatDateOnly(svc.ultimo_reset) : 'Sin recarga';

    return (
        <span className="text-muted font-weight-normal small ml-1">
            · {periodo} · Fecha recarga: {fechaRecarga} · Últ. renovación: {ultimaRenovacion}
        </span>
    );
};

const SERVICIOS_RESET_GLOBAL = ['fev', 'sms', 'whatsapp'];

const getPlantillasPagina = (lista, pagina) => {
    const inicio = (pagina - 1) * PLANTILLAS_POR_PAGINA;
    return lista.slice(inicio, inicio + PLANTILLAS_POR_PAGINA);
};

const nombreUsuario = (u) => {
    const n = [u.name, u.lastname].filter(Boolean).join(' ').trim();
    return n || u.email || u.login || `Usuario #${u.id}`;
};

const etiquetaTipoUsuario = (u) => {
    if (Number(u.usuario_actualizado) !== 1) return 'Pendiente migración';
    return Number(u.tipo_usuario) === 0 ? 'Médico' : 'Administrativo';
};

const AccordionSeccion = ({ abierto, onToggle, icono, titulo, acciones, children, bodyClass = '' }) => (
    <div className="card cliente-info-accordion mb-3">
        <div className="card-header py-2">
            <div className="d-flex align-items-center w-100">
                <h4 className="card-title mb-0 flex-grow-1">
                    <button
                        type="button"
                        className="btn btn-link d-block w-100 text-left p-0"
                        onClick={onToggle}
                        aria-expanded={abierto}
                        style={{ textDecoration: 'none', color: 'inherit', fontWeight: 'bold' }}
                    >
                        <i className={`${icono} mr-2 ${icono.includes('text-') ? '' : 'text-info'}`}></i>
                        {titulo}
                    </button>
                </h4>
                {acciones && (
                    <div className="flex-shrink-0 ml-2" onClick={(e) => e.stopPropagation()}>
                        {acciones}
                    </div>
                )}
            </div>
        </div>
        <div className={`collapse ${abierto ? 'show' : ''}`}>
            <div className={`card-body ${bodyClass}`}>{children}</div>
        </div>
    </div>
);

const ClienteInformacion = () => {
    const history = useHistory();
    const { clienteId } = useParams();
    const [loading, setLoading] = useState(true);
    const [resumen, setResumen] = useState(null);
    const [errorCarga, setErrorCarga] = useState('');
    const [alert, setAlert] = useState({ show: false, type: '', message: '' });

    const [editWhatsapp, setEditWhatsapp] = useState(false);
    const [editSms, setEditSms] = useState(false);
    const [editArchivos, setEditArchivos] = useState(false);
    const [limiteWhatsapp, setLimiteWhatsapp] = useState(0);
    const [limiteSms, setLimiteSms] = useState(0);
    const [limiteArchivosGb, setLimiteArchivosGb] = useState(0);

    const [showModalFev, setShowModalFev] = useState(false);
    const [showModalFevNuevo, setShowModalFevNuevo] = useState(false);
    const [resolucionFevEdit, setResolucionFevEdit] = useState(null);
    const [fevForm, setFevForm] = useState({ habilitado: 0, consumo: 0 });
    const [fevNuevoForm, setFevNuevoForm] = useState(defaultFevNuevoForm());
    const [fevNuevoErrors, setFevNuevoErrors] = useState({});
    const [guardandoFev, setGuardandoFev] = useState(false);
    const [guardandoFevNuevo, setGuardandoFevNuevo] = useState(false);

    const [showModalPlantillas, setShowModalPlantillas] = useState(false);
    const [plantillasDisponibles, setPlantillasDisponibles] = useState([]);
    const [cargandoPlantillas, setCargandoPlantillas] = useState(false);
    const [plantillasSeleccionadas, setPlantillasSeleccionadas] = useState([]);
    const [paginaPlantillas, setPaginaPlantillas] = useState(1);
    const [asignandoPlantillas, setAsignandoPlantillas] = useState(false);
    const [deshabilitandoPlantillaId, setDeshabilitandoPlantillaId] = useState(null);

    const [acordeonDatos, setAcordeonDatos] = useState(true);
    const [acordeonWhatsapp, setAcordeonWhatsapp] = useState(false);
    const [acordeonSms, setAcordeonSms] = useState(false);
    const [acordeonArchivos, setAcordeonArchivos] = useState(false);
    const [acordeonFev, setAcordeonFev] = useState(false);
    const [acordeonUsuarios, setAcordeonUsuarios] = useState(false);
    const [acordeonPlantillas, setAcordeonPlantillas] = useState(false);
    const [resetting, setResetting] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('superadmin_token');
        if (!token) {
            history.push('/superadmin/login');
            return;
        }
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
        cargarResumen();
    }, [history, clienteId]);

    const cargarResumen = async () => {
        try {
            setLoading(true);
            setErrorCarga('');
            const token = localStorage.getItem('superadmin_token');
            const headers = token ? { Authorization: `Bearer ${token}` } : {};
            const response = await axios.get(`/superadmin/clientes/${clienteId}/resumen`, { headers });
            if (response.data?.cliente) {
                setResumen(response.data);
                return;
            }
            setErrorCarga('La respuesta del servidor no incluyó datos del cliente.');
        } catch (error) {
            console.error(error);
            if (error.response?.status === 401) {
                history.push('/superadmin/login');
                return;
            }
            if (error.response?.status === 404) {
                setErrorCarga(error.response?.data?.message || 'Cliente no encontrado.');
                return;
            }
            const detalle = error.response?.data?.message || error.response?.data?.details || error.message;
            setErrorCarga(detalle || 'No se pudo cargar la información del cliente.');
        } finally {
            setLoading(false);
        }
    };

    const guardarLimiteWhatsapp = async () => {
        try {
            if (resumen?.whatsapp) {
                await axios.put(`/superadmin/whatsapp/${clienteId}/limite`, { limite_mensual: limiteWhatsapp });
            } else {
                await axios.post('/superadmin/whatsapp', { client_id: parseInt(clienteId, 10), limite_mensual: limiteWhatsapp });
            }
            setEditWhatsapp(false);
            cargarResumen();
            setAlert({ show: true, type: 'success', message: 'Límite de WhatsApp actualizado.' });
        } catch (e) {
            setAlert({ show: true, type: 'danger', message: e.response?.data?.message || 'Error al guardar WhatsApp.' });
        }
    };

    const abrirEditarFev = (resolucion) => {
        setResolucionFevEdit(resolucion);
        setFevForm({
            habilitado: resolucion.habilitado || 0,
            consumo: resolucion.consumo || 0,
        });
        setShowModalFev(true);
    };

    const abrirNuevaFev = () => {
        setFevNuevoForm(defaultFevNuevoForm());
        setFevNuevoErrors({});
        setShowModalFevNuevo(true);
    };

    const guardarFevNuevo = async (e) => {
        e.preventDefault();
        try {
            setGuardandoFevNuevo(true);
            setFevNuevoErrors({});
            await axios.post(`/superadmin/clientes/${clienteId}/parametros-fev`, {
                ...fevNuevoForm,
                habilitado: parseInt(fevNuevoForm.habilitado, 10) || 0,
                users_id: fevNuevoForm.users_id ? parseInt(fevNuevoForm.users_id, 10) : null,
                fecha_vencimiento: fevNuevoForm.fecha_vencimiento || null,
            });
            setShowModalFevNuevo(false);
            cargarResumen();
            setAlert({ show: true, type: 'success', message: 'Resolución FEV creada.' });
        } catch (err) {
            const data = err.response?.data;
            if (data?.errors) {
                const next = {};
                Object.keys(data.errors).forEach((key) => {
                    const val = data.errors[key];
                    next[key] = Array.isArray(val) ? val[0] : val;
                });
                setFevNuevoErrors(next);
            }
            setAlert({
                show: true,
                type: 'danger',
                message: data?.message || 'Error al crear resolución FEV.',
            });
        } finally {
            setGuardandoFevNuevo(false);
        }
    };

    const guardarFev = async () => {
        if (!resolucionFevEdit) return;
        try {
            setGuardandoFev(true);
            await axios.put(`/superadmin/parametros-fev/${resolucionFevEdit.id}`, {
                habilitado: fevForm.habilitado,
                consumo: fevForm.consumo,
            });
            setShowModalFev(false);
            cargarResumen();
            setAlert({ show: true, type: 'success', message: 'Resolución FEV actualizada.' });
        } catch (e) {
            setAlert({ show: true, type: 'danger', message: e.response?.data?.message || 'Error al guardar FEV.' });
        } finally {
            setGuardandoFev(false);
        }
    };

    const abrirAsignarPlantillas = async () => {
        setShowModalPlantillas(true);
        setPlantillasSeleccionadas([]);
        setPaginaPlantillas(1);
        try {
            setCargandoPlantillas(true);
            const response = await axios.get(`/superadmin/clientes/${clienteId}/plantillas-disponibles`);
            setPlantillasDisponibles(ordenarListaAlfabetica(Array.isArray(response.data) ? response.data : [], 'nombre'));
        } catch (e) {
            setShowModalPlantillas(false);
            setAlert({ show: true, type: 'danger', message: e.response?.data?.message || 'Error al cargar plantillas disponibles.' });
        } finally {
            setCargandoPlantillas(false);
        }
    };

    const togglePlantillaSeleccion = (id) => {
        setPlantillasSeleccionadas((prev) => (
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        ));
    };

    const toggleTodasPlantillasPagina = (marcar, idsPagina) => {
        if (marcar) {
            setPlantillasSeleccionadas((prev) => [...new Set([...prev, ...idsPagina])]);
        } else {
            setPlantillasSeleccionadas((prev) => prev.filter((id) => !idsPagina.includes(id)));
        }
    };

    const asignarPlantillasSeleccionadas = async () => {
        if (plantillasSeleccionadas.length === 0) {
            setAlert({ show: true, type: 'warning', message: 'Seleccione al menos una plantilla.' });
            return;
        }
        try {
            setAsignandoPlantillas(true);
            const response = await axios.post(`/superadmin/clientes/${clienteId}/asignar-plantillas`, {
                plantilla_admin_ids: plantillasSeleccionadas,
            });
            setShowModalPlantillas(false);
            setPlantillasSeleccionadas([]);
            cargarResumen();
            setAlert({
                show: true,
                type: 'success',
                message: response.data?.message || 'Plantillas asignadas correctamente.',
            });
        } catch (e) {
            setAlert({ show: true, type: 'danger', message: e.response?.data?.message || 'Error al asignar plantillas.' });
        } finally {
            setAsignandoPlantillas(false);
        }
    };

    const deshabilitarPlantillaCliente = async (plantilla) => {
        if (!plantilla?.id) return;
        if (!(plantilla.activo === 1 || plantilla.activo === true)) {
            setAlert({ show: true, type: 'warning', message: 'La plantilla ya está deshabilitada.' });
            return;
        }
        const msg = `¿Deshabilitar la plantilla "${plantilla.nombre}" en este cliente?\n\n`
            + 'Se quitará de todos los usuarios y no podrán usarla para nuevas historias. '
            + 'Las historias ya registradas se conservan.';
        if (!window.confirm(msg)) return;

        try {
            setDeshabilitandoPlantillaId(plantilla.id);
            const response = await axios.post(
                `/superadmin/clientes/${clienteId}/plantillas-historia/${plantilla.id}/deshabilitar`
            );
            cargarResumen();
            setAlert({
                show: true,
                type: 'success',
                message: response.data?.message || 'Plantilla deshabilitada correctamente.',
            });
        } catch (e) {
            setAlert({
                show: true,
                type: 'danger',
                message: e.response?.data?.message || 'Error al deshabilitar la plantilla.',
            });
        } finally {
            setDeshabilitandoPlantillaId(null);
        }
    };

    const guardarLimiteSms = async () => {
        try {
            if (resumen?.sms) {
                await axios.put(`/superadmin/sms/${clienteId}/limite`, { limite_mensual: limiteSms });
            } else {
                await axios.post('/superadmin/sms', { client_id: parseInt(clienteId, 10), limite_mensual: limiteSms });
            }
            setEditSms(false);
            cargarResumen();
            setAlert({ show: true, type: 'success', message: 'Límite de SMS actualizado.' });
        } catch (e) {
            setAlert({ show: true, type: 'danger', message: e.response?.data?.message || 'Error al guardar SMS.' });
        }
    };

    const guardarLimiteArchivos = async () => {
        try {
            await axios.put(`/superadmin/archivos-clinicos/${clienteId}/limite`, {
                almacenamiento_limite_gb: parseFloat(limiteArchivosGb) || 0,
            });
            setEditArchivos(false);
            cargarResumen();
            setAlert({ show: true, type: 'success', message: 'Cuota de archivos clínicos actualizada.' });
        } catch (e) {
            setAlert({ show: true, type: 'danger', message: e.response?.data?.message || 'Error al guardar cuota.' });
        }
    };

    const recalcularConsumoArchivos = async () => {
        try {
            await axios.post(`/superadmin/archivos-clinicos/${clienteId}/recalcular`);
            cargarResumen();
            setAlert({ show: true, type: 'success', message: 'Consumo recalculado desde archivos.' });
        } catch (e) {
            setAlert({ show: true, type: 'danger', message: e.response?.data?.message || 'Error al recalcular.' });
        }
    };

    const ejecutarResetServicios = async (modo) => {
        const accion = modo === 'periodo' ? 'Resetear periodo' : 'Resetear contadores';

        if (!window.confirm(`${accion} de FEV, SMS y WhatsApp?\n\n${
            modo === 'periodo'
                ? 'Solo aplica si hoy >= fecha de recarga de cada servicio. Avanza periodo y registra última renovación.'
                : 'Solo pone contadores en 0; no valida fechas ni avanza periodo.'
        }`)) {
            return;
        }

        try {
            setResetting(modo);
            const res = await axios.post(`/superadmin/clientes/${clienteId}/servicios/reset`, {
                modo,
                servicios: SERVICIOS_RESET_GLOBAL,
            });
            await cargarResumen();
            const omitidos = res.data?.omitidos || [];
            const ok = res.data?.ok || [];
            setAlert({
                show: true,
                type: ok.length === 0 && omitidos.length > 0 ? 'warning' : 'success',
                message: res.data?.message || 'Reset aplicado correctamente.',
            });
        } catch (e) {
            setAlert({
                show: true,
                type: 'danger',
                message: e.response?.data?.message || e.response?.data?.details || 'Error al resetear servicios.',
            });
        } finally {
            setResetting(null);
        }
    };

    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner-border text-info" role="status"><span className="sr-only">Cargando...</span></div>
            </div>
        );
    }

    if (!resumen?.cliente) {
        return (
            <SuperadminLayout>
                <div className="alert alert-warning">
                    {errorCarga || 'Cliente no encontrado.'}
                </div>
                <Link to="/superadmin/clientes" className="btn btn-secondary">Volver al listado</Link>
            </SuperadminLayout>
        );
    }

    const { cliente, usuarios_activos, whatsapp, sms, archivos_clinicos, resoluciones_fev, plantillas, servicios } = resumen;

    const totalPaginasPlantillas = Math.max(1, Math.ceil(plantillasDisponibles.length / PLANTILLAS_POR_PAGINA));
    const paginaPlantillasActiva = Math.min(paginaPlantillas, totalPaginasPlantillas);
    const plantillasPagina = getPlantillasPagina(plantillasDisponibles, paginaPlantillasActiva);
    const idsPlantillasPagina = plantillasPagina.map((p) => p.id);
    const todasPaginaSeleccionadas = plantillasPagina.length > 0
        && plantillasPagina.every((p) => plantillasSeleccionadas.includes(p.id));

    return (
        <SuperadminLayout>
            <nav aria-label="breadcrumb" className="mb-2">
                <ol className="breadcrumb bg-transparent p-0 mb-1 small">
                    <li className="breadcrumb-item"><Link to="/superadmin/clientes">Clientes</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Información del cliente</li>
                </ol>
            </nav>

            <div className="d-flex flex-wrap justify-content-between align-items-start mb-3">
                <div>
                    <h1 className="h4 mb-1">
                        <i className="fas fa-building text-info"></i> {cliente.nombre}
                    </h1>
                    <span className={`badge badge-${getEstadoBadgeClass(cliente.estado)}`}>{getEstadoLabel(cliente.estado)}</span>
                </div>
                <div className="d-flex flex-wrap mt-2 mt-md-0" style={{ gap: '8px' }}>
                    <Link to="/superadmin/clientes" className="btn btn-sm btn-outline-secondary">
                        <i className="fas fa-arrow-left"></i> Volver
                    </Link>
                    <Link to={`/superadmin/clientes/editar/${clienteId}`} className="btn btn-dark btn-sm">
                        <i className="fas fa-edit"></i> Editar
                    </Link>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-warning"
                        disabled={!!resetting}
                        title="Solo pone contadores en 0 (FEV, SMS, WhatsApp)"
                        onClick={() => ejecutarResetServicios('contadores')}
                    >
                        {resetting === 'contadores' ? '…' : (
                            <>
                                <i className="fas fa-sync-alt"></i> Resetear
                            </>
                        )}
                    </button>
                    <button
                        type="button"
                        className="btn btn-sm btn-outline-danger"
                        disabled={!!resetting}
                        title="Contadores en 0 + avanza periodos y registra última recarga"
                        onClick={() => ejecutarResetServicios('periodo')}
                    >
                        {resetting === 'periodo' ? '…' : (
                            <>
                                <i className="fas fa-sync-alt"></i> Resetear Periodo
                            </>
                        )}
                    </button>
                    <Link to={`/superadmin/clientes/${clienteId}/usuarios`} className="btn btn-info btn-sm">
                        <i className="fas fa-users"></i> Usuarios
                    </Link>
                </div>
            </div>

            {alert.show && (
                <div className={`alert alert-${alert.type} alert-dismissible fade show`}>
                    {alert.message}
                    <button type="button" className="close" onClick={() => setAlert({ show: false, type: '', message: '' })}><span>&times;</span></button>
                </div>
            )}

            <div className="row">
                <div className="col-md-12">
                    <AccordionSeccion
                        abierto={acordeonDatos}
                        onToggle={() => setAcordeonDatos(!acordeonDatos)}
                        icono="fas fa-id-card-alt"
                        titulo="Datos básicos"
                    >
                        <div className="row small">
                            <div className="col-md-4">
                                <p className="mb-1"><strong>NIT:</strong> {cliente.nit || '—'}</p>
                                <p className="mb-1"><strong>Razón social:</strong> {cliente.razon_social || '—'}</p>
                                <p className="mb-1"><strong>Email contacto:</strong> {cliente.email_contacto || '—'}</p>
                                <p className="mb-0"><strong>Teléfono:</strong> {cliente.telefono || '—'}</p>
                            </div>
                            <div className="col-md-4">
                                <p className="mb-1"><strong>Contrato:</strong> {cliente.tipo_contrato || '—'}</p>
                                <p className="mb-1"><strong>Fecha de suscripción:</strong> {formatDateOnly(cliente.fecha_suscripcion) || '—'}</p>
                                <p className="mb-1"><strong>Vencimiento:</strong> {formatDateOnly(cliente.fecha_vencimiento) || 'Sin vencimiento'}</p>
                                <p className="mb-1"><strong>Bloqueo:</strong> {formatDateOnly(cliente.fecha_bloqueo) || 'Sin bloqueo auto.'}</p>
                                <p className="mb-0"><strong>Última renovación:</strong> {formatDateOnly(cliente.fecha_renovacion) || '—'}</p>
                            </div>
                            <div className="col-md-4">
                                <p className="mb-1">
                                    <strong>Cupos médicos:</strong>{' '}
                                    {cliente.usuarios_medicos_creados ?? 0} / {cliente.usuarios_medicos_disponibles ?? 0}
                                </p>
                                <p className="mb-1">
                                    <strong>Cupos administrativos:</strong>{' '}
                                    {cliente.usuarios_administrativos_creados ?? 0} / {cliente.usuarios_administrativos_disponibles ?? 0}
                                </p>
                                <p className="mb-0">
                                    <strong>Total licencias / personal activo:</strong>{' '}
                                    {(cliente.usuarios_medicos_disponibles ?? 0) + (cliente.usuarios_administrativos_disponibles ?? 0)} / {cliente.usuarios_actuales || 0}
                                </p>
                            </div>
                        </div>
                    </AccordionSeccion>

                    <AccordionSeccion
                        abierto={acordeonWhatsapp}
                        onToggle={() => setAcordeonWhatsapp(!acordeonWhatsapp)}
                        icono="fab fa-whatsapp text-success"
                        titulo={(
                            <>
                                WhatsApp
                                {subtituloControlServicio(servicios?.whatsapp)}
                            </>
                        )}
                        acciones={(
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => {
                                    setLimiteWhatsapp(whatsapp?.limite_mensual ?? 100);
                                    setEditWhatsapp(true);
                                }}
                            >
                                {whatsapp ? 'Editar límite' : 'Crear límite'}
                            </button>
                        )}
                    >
                        {whatsapp ? (
                            <div className="row small">
                                <div className="col-sm-3"><strong>Límite mensual:</strong> {whatsapp.limite_mensual}</div>
                                <div className="col-sm-3"><strong>Consumo:</strong> {whatsapp.consumo_actual}</div>
                                <div className="col-sm-3"><strong>Disponible:</strong> {Math.max(0, (whatsapp.limite_mensual || 0) - (whatsapp.consumo_actual || 0))}</div>
                                <div className="col-sm-3"><strong>Activo:</strong> {whatsapp.activo ? 'Sí' : 'No'}</div>
                            </div>
                        ) : (
                            <p className="text-muted mb-2 small">Sin límite configurado.</p>
                        )}
                        <Link to="/superadmin/whatsapp" className="btn btn-link btn-sm px-0">Panel global WhatsApp</Link>
                    </AccordionSeccion>

                    <AccordionSeccion
                        abierto={acordeonSms}
                        onToggle={() => setAcordeonSms(!acordeonSms)}
                        icono="fas fa-sms"
                        titulo={(
                            <>
                                SMS
                                {subtituloControlServicio(servicios?.sms)}
                            </>
                        )}
                        acciones={(
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => {
                                    setLimiteSms(sms?.limite_mensual ?? 100);
                                    setEditSms(true);
                                }}
                            >
                                {sms ? 'Editar límite' : 'Crear límite'}
                            </button>
                        )}
                    >
                        {sms ? (
                            <div className="row small">
                                <div className="col-sm-4"><strong>Límite mensual:</strong> {sms.limite_mensual}</div>
                                <div className="col-sm-4"><strong>Consumo:</strong> {sms.consumo_actual}</div>
                                <div className="col-sm-4"><strong>Activo:</strong> {sms.activo ? 'Sí' : 'No'}</div>
                            </div>
                        ) : (
                            <p className="text-muted mb-2 small">Sin límite configurado.</p>
                        )}
                        <Link to="/superadmin/sms" className="btn btn-link btn-sm px-0">Panel global SMS</Link>
                    </AccordionSeccion>

                    <AccordionSeccion
                        abierto={acordeonArchivos}
                        onToggle={() => setAcordeonArchivos(!acordeonArchivos)}
                        icono="fas fa-images"
                        titulo="Archivos clínicos"
                        acciones={(
                            <>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-secondary mr-1"
                                    onClick={recalcularConsumoArchivos}
                                    title="Recalcular consumo"
                                >
                                    <i className="fas fa-sync-alt"></i>
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => {
                                        setLimiteArchivosGb(archivos_clinicos?.almacenamiento_limite_gb ?? 0);
                                        setEditArchivos(true);
                                    }}
                                >
                                    Editar cuota
                                </button>
                            </>
                        )}
                    >
                        {archivos_clinicos?.modulo_habilitado ? (
                            <div className="row small">
                                <div className="col-sm-3"><strong>Límite:</strong> {archivos_clinicos.almacenamiento_limite_gb} GB</div>
                                <div className="col-sm-3"><strong>Consumo:</strong> {archivos_clinicos.almacenamiento_consumo_gb} GB</div>
                                <div className="col-sm-3"><strong>Uso:</strong> {archivos_clinicos.porcentaje_uso}%</div>
                                <div className="col-sm-3">
                                    <strong>Estado:</strong>{' '}
                                    {archivos_clinicos.porcentaje_uso >= 95 ? (
                                        <span className="text-danger">Crítico</span>
                                    ) : archivos_clinicos.porcentaje_uso >= 80 ? (
                                        <span className="text-warning">Alerta</span>
                                    ) : (
                                        <span className="text-success">Normal</span>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <p className="text-muted mb-2 small">Módulo deshabilitado (cuota 0 GB).</p>
                        )}
                        <Link to="/superadmin/archivos-clinicos" className="btn btn-link btn-sm px-0">Panel global archivos clínicos</Link>
                    </AccordionSeccion>

                    <AccordionSeccion
                        abierto={acordeonFev}
                        onToggle={() => setAcordeonFev(!acordeonFev)}
                        icono="fas fa-file-invoice"
                        titulo={(
                            <>
                                Facturación electrónica (FEV)
                                {subtituloControlServicio(servicios?.fev)}
                            </>
                        )}
                        acciones={(
                            <>
                                <button type="button" className="btn btn-sm btn-primary mr-1" onClick={abrirNuevaFev}>
                                    <i className="fas fa-plus"></i> Nueva resolución
                                </button>
                                <Link to="/superadmin/parametros-fev" className="btn btn-sm btn-outline-secondary">Panel FEV</Link>
                            </>
                        )}
                        bodyClass="p-0"
                    >
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0">
                                <thead className="thead-light">
                                    <tr>
                                        <th>Prefijo</th>
                                        <th>Resolución</th>
                                        <th>Profesional / Usuario</th>
                                        <th>Habilitado</th>
                                        <th>Consumo</th>
                                        <th>Disponibles</th>
                                        <th style={{ width: '48px' }}></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {resoluciones_fev?.length > 0 ? resoluciones_fev.map((r) => (
                                        <tr key={r.id}>
                                            <td>{r.prefijo}</td>
                                            <td>{r.resolucion}</td>
                                            <td>
                                                {(r.usuario_nombre_completo || r.usuario_nombre || '').trim()
                                                    || r.usuario_email
                                                    || <span className="text-muted">Sin asignar</span>}
                                            </td>
                                            <td>{r.habilitado}</td>
                                            <td>{r.consumo}</td>
                                            <td>{r.disponibles}</td>
                                            <td className="text-center">
                                                <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-secondary py-0 px-1"
                                                    title="Editar habilitado y consumo"
                                                    onClick={() => abrirEditarFev(r)}
                                                >
                                                    <i className="fas fa-edit"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="7" className="text-center text-muted py-3">Sin resoluciones FEV</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </AccordionSeccion>

                    <AccordionSeccion
                        abierto={acordeonUsuarios}
                        onToggle={() => setAcordeonUsuarios(!acordeonUsuarios)}
                        icono="fas fa-users"
                        titulo={`Usuarios activos (${usuarios_activos?.length || 0})`}
                        acciones={(
                            <Link to={`/superadmin/clientes/${clienteId}/usuarios`} className="btn btn-sm btn-info">Gestionar</Link>
                        )}
                        bodyClass="p-0"
                    >
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0">
                                <thead className="thead-light">
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Email</th>
                                        <th>Login</th>
                                        <th>Tipo</th>
                                        <th>Sistema</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {usuarios_activos?.length > 0 ? usuarios_activos.map((u) => (
                                        <tr key={u.id}>
                                            <td>{nombreUsuario(u)}</td>
                                            <td>{u.email}</td>
                                            <td>{u.login || '—'}</td>
                                            <td>{etiquetaTipoUsuario(u)}</td>
                                            <td>{Number(u.usuario_sistema) === 1 ? 'Sí' : 'No'}</td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="5" className="text-center text-muted py-3">Sin usuarios activos</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </AccordionSeccion>

                    <AccordionSeccion
                        abierto={acordeonPlantillas}
                        onToggle={() => setAcordeonPlantillas(!acordeonPlantillas)}
                        icono="fas fa-file-medical"
                        titulo={`Plantillas de historia (${plantillas?.length || 0})`}
                        acciones={(
                            <>
                                <button type="button" className="btn btn-sm btn-primary mr-1" onClick={abrirAsignarPlantillas}>
                                    <i className="fas fa-plus"></i> Asignar
                                </button>
                                <Link to="/superadmin/plantillas" className="btn btn-sm btn-outline-secondary">Admin</Link>
                            </>
                        )}
                        bodyClass="p-0"
                    >
                        <div className="table-responsive">
                            <table className="table table-sm table-hover mb-0">
                                <thead className="thead-light">
                                    <tr>
                                        <th>Nombre</th>
                                        <th>Especialidad</th>
                                        <th>Estado</th>
                                        <th>Origen admin</th>
                                        <th className="text-center">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {plantillas?.length > 0 ? plantillas.map((p) => (
                                        <tr key={p.id} className={!(p.activo === 1 || p.activo === true) ? 'text-muted' : ''}>
                                            <td>{p.nombre}</td>
                                            <td>{p.especialidad || '—'}</td>
                                            <td>
                                                {p.activo === 1 || p.activo === true ? (
                                                    <span className="badge badge-success">Activa</span>
                                                ) : (
                                                    <span className="badge badge-secondary">Deshabilitada</span>
                                                )}
                                            </td>
                                            <td>{p.plantilla_admin_id ? `#${p.plantilla_admin_id}` : 'Propia'}</td>
                                            <td className="text-center">
                                                {(p.activo === 1 || p.activo === true) ? (
                                                    <button
                                                        type="button"
                                                        className="btn btn-sm btn-outline-warning"
                                                        title="Deshabilitar plantilla en este cliente"
                                                        disabled={deshabilitandoPlantillaId === p.id}
                                                        onClick={() => deshabilitarPlantillaCliente(p)}
                                                    >
                                                        {deshabilitandoPlantillaId === p.id ? (
                                                            <i className="fas fa-spinner fa-spin"></i>
                                                        ) : (
                                                            <><i className="fas fa-ban mr-1"></i> Deshabilitar</>
                                                        )}
                                                    </button>
                                                ) : (
                                                    <span className="text-muted small">—</span>
                                                )}
                                            </td>
                                        </tr>
                                    )) : (
                                        <tr><td colSpan="5" className="text-center text-muted py-3">Sin plantillas en este cliente</td></tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </AccordionSeccion>
                </div>
            </div>

            <Modal show={editWhatsapp} onHide={() => setEditWhatsapp(false)}>
                <Modal.Header closeButton><Modal.Title>Límite WhatsApp</Modal.Title></Modal.Header>
                <Modal.Body>
                    <label>Límite mensual</label>
                    <input type="number" className="form-control" min="0" value={limiteWhatsapp} onChange={(e) => setLimiteWhatsapp(parseInt(e.target.value, 10) || 0)} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setEditWhatsapp(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={guardarLimiteWhatsapp}>Guardar</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={editSms} onHide={() => setEditSms(false)}>
                <Modal.Header closeButton><Modal.Title>Límite SMS</Modal.Title></Modal.Header>
                <Modal.Body>
                    <label>Límite mensual</label>
                    <input type="number" className="form-control" min="0" value={limiteSms} onChange={(e) => setLimiteSms(parseInt(e.target.value, 10) || 0)} />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setEditSms(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={guardarLimiteSms}>Guardar</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={editArchivos} onHide={() => setEditArchivos(false)}>
                <Modal.Header closeButton><Modal.Title>Cuota archivos clínicos</Modal.Title></Modal.Header>
                <Modal.Body>
                    <label>Límite (GB)</label>
                    <input
                        type="number"
                        className="form-control"
                        min="0"
                        step="0.5"
                        value={limiteArchivosGb}
                        onChange={(e) => setLimiteArchivosGb(e.target.value)}
                    />
                    <small className="form-text text-muted">0 GB deshabilita el módulo en atención al paciente.</small>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setEditArchivos(false)}>Cancelar</Button>
                    <Button variant="primary" onClick={guardarLimiteArchivos}>Guardar</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalFev} onHide={() => setShowModalFev(false)} size="sm">
                <Modal.Header closeButton>
                    <Modal.Title>Editar FEV</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {resolucionFevEdit && (
                        <>
                            <p className="small mb-2">
                                <strong>Prefijo:</strong> {resolucionFevEdit.prefijo}<br />
                                <strong>Resolución:</strong> {resolucionFevEdit.resolucion}
                            </p>
                            <div className="form-group">
                                <label>Habilitado</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    min="0"
                                    value={fevForm.habilitado}
                                    onChange={(e) => setFevForm({ ...fevForm, habilitado: parseInt(e.target.value, 10) || 0 })}
                                />
                            </div>
                            <div className="form-group mb-0">
                                <label>Consumo</label>
                                <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    min="0"
                                    value={fevForm.consumo}
                                    onChange={(e) => setFevForm({ ...fevForm, consumo: parseInt(e.target.value, 10) || 0 })}
                                />
                            </div>
                            <p className="small text-muted mt-2 mb-0">
                                Disponibles tras guardar: {Math.max(0, (fevForm.habilitado || 0) - (fevForm.consumo || 0))}
                            </p>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" size="sm" onClick={() => setShowModalFev(false)}>Cancelar</Button>
                    <Button variant="dark" size="sm" onClick={guardarFev} disabled={guardandoFev}>
                        {guardandoFev ? 'Guardando…' : 'Guardar'}
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showModalFevNuevo} onHide={() => setShowModalFevNuevo(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Nueva resolución FEV</Modal.Title>
                </Modal.Header>
                <form onSubmit={guardarFevNuevo}>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="fev-resolucion">Resolución número</label>
                                    <input
                                        type="text"
                                        id="fev-resolucion"
                                        className={`form-control form-control-sm${fevNuevoErrors.resolucion ? ' is-invalid' : ''}`}
                                        value={fevNuevoForm.resolucion}
                                        onChange={(e) => setFevNuevoForm({ ...fevNuevoForm, resolucion: e.target.value })}
                                        required
                                    />
                                    {fevNuevoErrors.resolucion && (
                                        <div className="invalid-feedback d-block">{fevNuevoErrors.resolucion}</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="fev-prefijo">Prefijo</label>
                                    <input
                                        type="text"
                                        id="fev-prefijo"
                                        className={`form-control form-control-sm${fevNuevoErrors.prefijo ? ' is-invalid' : ''}`}
                                        value={fevNuevoForm.prefijo}
                                        onChange={(e) => setFevNuevoForm({ ...fevNuevoForm, prefijo: e.target.value })}
                                        required
                                    />
                                    {fevNuevoErrors.prefijo && (
                                        <div className="invalid-feedback d-block">{fevNuevoErrors.prefijo}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="fev-tipo">Tipo de documento</label>
                                    <select
                                        id="fev-tipo"
                                        className="form-control form-control-sm"
                                        value={fevNuevoForm.tipo}
                                        onChange={(e) => setFevNuevoForm({ ...fevNuevoForm, tipo: e.target.value })}
                                    >
                                        <option value="Factura Electronica">Factura Electrónica</option>
                                        <option value="Nota Credito">Nota Crédito</option>
                                        <option value="Documento Soporte">Documento Soporte</option>
                                        <option value="Nota Documento Soporte">Nota Documento Soporte</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label htmlFor="fev-numero">Próximo consecutivo</label>
                                    <input
                                        type="text"
                                        id="fev-numero"
                                        className={`form-control form-control-sm${fevNuevoErrors.numero_factura ? ' is-invalid' : ''}`}
                                        value={fevNuevoForm.numero_factura}
                                        onChange={(e) => setFevNuevoForm({ ...fevNuevoForm, numero_factura: e.target.value })}
                                        required
                                    />
                                    {fevNuevoErrors.numero_factura && (
                                        <div className="invalid-feedback d-block">{fevNuevoErrors.numero_factura}</div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="fev-inicial">Desde el número</label>
                                    <input
                                        type="text"
                                        id="fev-inicial"
                                        className={`form-control form-control-sm${fevNuevoErrors.factura_inicial ? ' is-invalid' : ''}`}
                                        value={fevNuevoForm.factura_inicial}
                                        onChange={(e) => setFevNuevoForm({ ...fevNuevoForm, factura_inicial: e.target.value })}
                                        required
                                    />
                                    {fevNuevoErrors.factura_inicial && (
                                        <div className="invalid-feedback d-block">{fevNuevoErrors.factura_inicial}</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="fev-final">Hasta el número</label>
                                    <input
                                        type="text"
                                        id="fev-final"
                                        className={`form-control form-control-sm${fevNuevoErrors.factura_final ? ' is-invalid' : ''}`}
                                        value={fevNuevoForm.factura_final}
                                        onChange={(e) => setFevNuevoForm({ ...fevNuevoForm, factura_final: e.target.value })}
                                        required
                                    />
                                    {fevNuevoErrors.factura_final && (
                                        <div className="invalid-feedback d-block">{fevNuevoErrors.factura_final}</div>
                                    )}
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="fev-vencimiento">Fecha vencimiento</label>
                                    <input
                                        type="date"
                                        id="fev-vencimiento"
                                        className="form-control form-control-sm"
                                        value={fevNuevoForm.fecha_vencimiento}
                                        onChange={(e) => setFevNuevoForm({ ...fevNuevoForm, fecha_vencimiento: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="fev-regimen">Tipo de régimen</label>
                                    <select
                                        id="fev-regimen"
                                        className="form-control form-control-sm"
                                        value={fevNuevoForm.tipo_regimen}
                                        onChange={(e) => setFevNuevoForm({ ...fevNuevoForm, tipo_regimen: e.target.value })}
                                    >
                                        <option value="Sin IVA">Sin IVA</option>
                                        <option value="Con IVA">Con IVA</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label htmlFor="fev-habilitado">Habilitado</label>
                                    <select
                                        id="fev-habilitado"
                                        className="form-control form-control-sm"
                                        value={fevNuevoForm.habilitado}
                                        onChange={(e) => setFevNuevoForm({ ...fevNuevoForm, habilitado: e.target.value })}
                                    >
                                        <option value={1}>Sí</option>
                                        <option value={0}>No</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="form-group mb-0">
                                    <label htmlFor="fev-usuario">Usuario</label>
                                    <select
                                        id="fev-usuario"
                                        className={`form-control form-control-sm${fevNuevoErrors.users_id ? ' is-invalid' : ''}`}
                                        value={fevNuevoForm.users_id}
                                        onChange={(e) => setFevNuevoForm({ ...fevNuevoForm, users_id: e.target.value })}
                                    >
                                        <option value="">Seleccionar usuario</option>
                                        {usuarios_activos?.map((u) => (
                                            <option key={u.id} value={u.id}>
                                                {nombreUsuario(u)}
                                            </option>
                                        ))}
                                    </select>
                                    {fevNuevoErrors.users_id && (
                                        <div className="invalid-feedback d-block">{fevNuevoErrors.users_id}</div>
                                    )}
                                    {(!usuarios_activos || usuarios_activos.length === 0) && (
                                        <small className="form-text text-muted">
                                            Sin usuarios activos. Puede crear uno desde la sección Usuarios.
                                        </small>
                                    )}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" size="sm" type="button" onClick={() => setShowModalFevNuevo(false)}>
                            Cancelar
                        </Button>
                        <Button variant="dark" size="sm" type="submit" disabled={guardandoFevNuevo}>
                            {guardandoFevNuevo ? 'Creando…' : 'Crear resolución'}
                        </Button>
                    </Modal.Footer>
                </form>
            </Modal>

            <Modal show={showModalPlantillas} onHide={() => setShowModalPlantillas(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Asignar plantillas de historia</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {cargandoPlantillas ? (
                        <div className="text-center py-4">
                            <div className="spinner-border spinner-border-sm text-info" role="status" />
                        </div>
                    ) : plantillasDisponibles.length === 0 ? (
                        <p className="text-muted mb-0">No hay plantillas admin disponibles para asignar (todas ya están en este cliente o no hay plantillas activas).</p>
                    ) : (
                        <>
                            <p className="small text-muted mb-2">
                                {plantillasSeleccionadas.length} seleccionada(s) · {plantillasDisponibles.length} disponible(s)
                            </p>
                            <div className="table-responsive cliente-modal-plantillas-tabla">
                                <table className="table table-sm table-hover mb-0">
                                    <thead className="thead-light">
                                        <tr>
                                            <th style={{ width: '40px' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={todasPaginaSeleccionadas}
                                                    onChange={(e) => toggleTodasPlantillasPagina(e.target.checked, idsPlantillasPagina)}
                                                    title="Seleccionar todas en esta página"
                                                />
                                            </th>
                                            <th>Nombre</th>
                                            <th>Especialidad</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {plantillasPagina.map((p) => (
                                            <tr key={p.id}>
                                                <td>
                                                    <input
                                                        type="checkbox"
                                                        checked={plantillasSeleccionadas.includes(p.id)}
                                                        onChange={() => togglePlantillaSeleccion(p.id)}
                                                    />
                                                </td>
                                                <td>{p.nombre}</td>
                                                <td>{p.especialidad || '—'}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {totalPaginasPlantillas > 1 && (
                                <nav className="mt-3" aria-label="Paginación plantillas">
                                    <ul className="pagination pagination-sm justify-content-center mb-0">
                                        <li className={`page-item ${paginaPlantillasActiva === 1 ? 'disabled' : ''}`}>
                                            <button
                                                type="button"
                                                className="page-link"
                                                onClick={() => setPaginaPlantillas(paginaPlantillasActiva - 1)}
                                                disabled={paginaPlantillasActiva === 1}
                                            >
                                                Anterior
                                            </button>
                                        </li>
                                        {[...Array(totalPaginasPlantillas)].map((_, index) => (
                                            <li
                                                key={index + 1}
                                                className={`page-item ${paginaPlantillasActiva === index + 1 ? 'active' : ''}`}
                                            >
                                                <button
                                                    type="button"
                                                    className="page-link"
                                                    onClick={() => setPaginaPlantillas(index + 1)}
                                                >
                                                    {index + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${paginaPlantillasActiva === totalPaginasPlantillas ? 'disabled' : ''}`}>
                                            <button
                                                type="button"
                                                className="page-link"
                                                onClick={() => setPaginaPlantillas(paginaPlantillasActiva + 1)}
                                                disabled={paginaPlantillasActiva === totalPaginasPlantillas}
                                            >
                                                Siguiente
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            )}
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModalPlantillas(false)}>Cancelar</Button>
                    <Button
                        variant="primary"
                        onClick={asignarPlantillasSeleccionadas}
                        disabled={asignandoPlantillas || plantillasSeleccionadas.length === 0 || cargandoPlantillas}
                    >
                        {asignandoPlantillas ? 'Asignando…' : `Asignar (${plantillasSeleccionadas.length})`}
                    </Button>
                </Modal.Footer>
            </Modal>
        </SuperadminLayout>
    );
};

export default ClienteInformacion;
